import PropTypes from 'prop-types'
import { SupportIcon } from '../../../ui/icons'

import c from './page-title.module.scss'

const PageTitle = ({ title, callback }) => {
    return (
        <div className={c.component}>
            <p>{title}</p>
            {callback && (
                <button type="button" className={c.btn} onClick={callback}>
                    <SupportIcon />
                </button>
            )}
        </div>
    )
}

PageTitle.propTypes = {
    title: PropTypes.string.isRequired,
    callback: PropTypes.func,
}

export default PageTitle
